// extracted by mini-css-extract-plugin
export default {"quantity_container":"TL","hiddenflavorstring":"UL","loadingLine":"VL","productimgwrap":"WL","productimg":"XL","circlepic":"YL","productinfo":"ZL","grey_x":"aM","cartrow":"bM","bold":"cM","title":"eM","blue":"fM","strike":"gM","flexgap":"hM","flavorstring":"iM","nodecorate":"jM","flavorstring_link":"kM","rdstring":"lM","removeditemblock":"mM","removed_heading":"nM","removed_text":"oM","addback":"pM"};
    if(module.hot) {
      // 1737143662413
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  